import styled from 'styled-components';

export const RowLine = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;

  p {
    margin-right: 1rem;
    text-align: left;
  }
  span {
    display: block;
  }
  .icontop {
    position: absolute;
    top: 5px;
    left: 5px;
  }
`;

export const SpanBlock = styled.span`
  display: block;
`;
export const ButtonsStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  padding: 1rem;
  border-radius: 2px;
  button {
    width: 100px !important;
    background-color: #006cd4;
    color: #fff;
    svg {
      color: #fff;
    }
  }
`;
